import { trackAppEvent } from "./appTracking";

/** Experience v3 home-funnel events — MUST stay in sync with the
 *  eventName enum in ClaryNext-BE/model/analytics_event.js */
export type HomeEventName =
  | "seeder_completed"
  | "arrangement_viewed"
  | "arrangement_project_clicked"
  | "arrangement_dismissed"
  | "today_task_completed"
  | "reflection_shown"
  | "reflection_answered"
  | "reflection_skipped"
  | "wisdom_saved"
  | "quick_capture_submitted"
  | "checkin_started";

export const trackHomeEvent = (
  eventName: HomeEventName,
  eventData: Record<string, unknown> = {}
): void => {
  trackAppEvent(eventName, eventData);
};
